var React = require('react');

function LiftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"5","y":"16","width":"54","height":"47","rx":"4","key":0}),React.createElement("circle",{"cx":"40","cy":"26","r":"3","key":1}),React.createElement("path",{"d":"M38.705 32h2.59a1 1 0 0 1 .942.664L47 46H33l4.763-13.336a1 1 0 0 1 .942-.664z","key":2}),React.createElement("circle",{"cx":"25","cy":"26","r":"3","key":3}),React.createElement("path",{"d":"M21.92 32h6.16a1 1 0 0 1 .996.917L30 44H20l.924-11.083A1 1 0 0 1 21.92 32zM23 56h4a1 1 0 0 0 1-1V44h-6v11a1 1 0 0 0 1 1zm2-54v10m-5-6l5-5 5 5m10 5V1m-5 6l5 5 5-5m-6.095 49h2.19a1 1 0 0 0 .995-.9L43 46h-6l.91 9.1a1 1 0 0 0 .995.9z","key":4})]));
}

LiftInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = LiftInline;

LiftInline.default = LiftInline;
